import { render, staticRenderFns } from "./AlfExceptions.vue?vue&type=template&id=08af8b2d"
import script from "./AlfExceptions.vue?vue&type=script&lang=js"
export * from "./AlfExceptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports